import { store } from '@/store';

import { registerTriggerHit } from '../store/reviewSlice';
import type { ReviewFlowTriggerKey } from '../types';
import { incrementReviewFlowTriggerCounter } from './reviewFlowTriggerCounters';

export function incrementReviewFlowTrigger(
  trigger: ReviewFlowTriggerKey,
  featureName?: string | null
): void {
  if (typeof window === 'undefined') return;

  const count = incrementReviewFlowTriggerCounter(trigger);

  store.dispatch(
    registerTriggerHit({ trigger, count, featureName: featureName ?? null })
  );
}
